{
    "name": "personal-account-frontend",
    "version": "6.0.1",
    "type": "module",
    "scripts": {
        "ng": "ng",
        "prestart": "npm i",
        "start": "npm run lint && ng serve --host=0.0.0.0 --port=4226",
        "prebuild": "npm i --silent",
        "build-local": "node scripts/build-with-metadata.mjs --base-href=/",
        "build": "node scripts/build-with-metadata.mjs --configuration production --optimization --source-map",
        "package:release": "node scripts/create-release-archive.mjs",
        "lint": "eslint \"**/*.ts\"",
        "watch": "ng build --watch --configuration development",
        "test": "ng test"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.2.25",
        "@angular/cdk": "^19.2.19",
        "@angular/common": "^19.2.25",
        "@angular/compiler": "^19.2.25",
        "@angular/core": "^19.2.25",
        "@angular/forms": "^19.2.25",
        "@angular/localize": "^19.2.25",
        "@angular/material": "^19.2.19",
        "@angular/material-luxon-adapter": "19.2.19",
        "@angular/platform-browser": "^19.2.25",
        "@angular/platform-browser-dynamic": "^19.2.25",
        "@angular/router": "^19.2.25",
        "@angular/service-worker": "^19.2.25",
        "@ng-bootstrap/ng-bootstrap": "^18.0.0",
        "axios": "^1.13.5",
        "bootstrap": "^5.3.3",
        "joi": "^17.9.2",
        "jsbarcode": "3.11.5",
        "jszip": "^3.10.1",
        "konva": "^9.2.1",
        "lottie-web": "^5.12.2",
        "luxon": "^3.7.2",
        "magic-wand-tool": "^1.1.7",
        "ngx-cookie-service": "^19.1.2",
        "ngx-lottie": "^12.0.0",
        "ngx-mask": "^16.2.2",
        "rxjs": "^7.8.1",
        "socket.io-client": "^4.8.0",
        "tslib": "^2.8.1",
        "vanilla-cookieconsent": "^3.1.0",
        "zone.js": "^0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.2.27",
        "@angular/cli": "^19.2.27",
        "@angular/compiler-cli": "^19.2.25",
        "@semantic-release/changelog": "^6.0.3",
        "@semantic-release/commit-analyzer": "^13.0.1",
        "@semantic-release/exec": "^7.1.0",
        "@semantic-release/git": "^10.0.1",
        "@semantic-release/gitlab": "^13.2.8",
        "@semantic-release/npm": "^12.0.2",
        "@semantic-release/release-notes-generator": "^14.1.0",
        "@types/joi": "^17.2.3",
        "@types/luxon": "^3.7.1",
        "@types/node": "^22.6.1",
        "@types/uuid": "9.0.2",
        "@types/ws": "^8.5.12",
        "eslint": "9.32.0",
        "eslint-config-prettier": "^10.1.8",
        "eslint-import-resolver-typescript": "^4.4.4",
        "eslint-plugin-import-x": "^4.16.1",
        "eslint-plugin-prettier": "^5.5.3",
        "semantic-release": "^24.2.9",
        "typescript": "~5.8.3",
        "typescript-eslint": "^8.38.0"
    }
}
